var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectedDate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.93331H1M9.66667 1.33331V4.13331M4.33333 1.33331V4.13331M4.2 15.3333H9.8C10.9201 15.3333 11.4802 15.3333 11.908 15.1044C12.2843 14.9031 12.5903 14.5818 12.782 14.1867C13 13.7375 13 13.1494 13 11.9733V6.09331C13 4.9172 13 4.32915 12.782 3.87993C12.5903 3.48479 12.2843 3.16353 11.908 2.9622C11.4802 2.73331 10.9201 2.73331 9.8 2.73331H4.2C3.0799 2.73331 2.51984 2.73331 2.09202 2.9622C1.71569 3.16353 1.40973 3.48479 1.21799 3.87993C1 4.32915 1 4.9172 1 6.09331V11.9733C1 13.1494 1 13.7375 1.21799 14.1867C1.40973 14.5818 1.71569 14.9031 2.09202 15.1044C2.51984 15.3333 3.0799 15.3333 4.2 15.3333Z",
    stroke: "#cda742",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedDate);
export default __webpack_public_path__ + "static/media/SelectedDate.bdb0965a0502282cf9b9ae6e1587a00c.svg";
export { ForwardRef as ReactComponent };